@if (form) {
  <app-ice-card [formGroup]="form">
    <section class="return-mobile-section">
      <div class="return-mobile-section-heading">1/{{ numberOfSteps }} Retur av gammel telefon</div>
      <header class="section-header">Velg returmetode</header>
      <div class="return-method-info">Valgt returmetode er endelig, og kan ikke endres når byttet er registrert.</div>
      <mat-radio-group formControlName="returnMethodControl">
        <app-radio-button-list>
          <app-radio-button-list-item
            [control]="form.controls.returnMethodControl"
            [value]="MobileReturnMethod.ReturnPackage"
          >
            <header>Send retureske til kunde</header>
            @if (form.controls.returnMethodControl.value === MobileReturnMethod.ReturnPackage) {
              <div class="return-method-info">Kunde klargjør telefonen selv, og sender returboks med posten.</div>
            }
          </app-radio-button-list-item>
          @if (isReturnPhoneInStoreEnabled === 'true') {
            <app-radio-button-list-item
              [control]="form.controls.returnMethodControl"
              [disabled]="canSellHardwareWithLogistics"
              [value]="MobileReturnMethod.ShopReturn"
            >
              <header>Returner i butikk</header>
            </app-radio-button-list-item>
          }
        </app-radio-button-list>
      </mat-radio-group>
      <section class="return-mobile-info-section">
        <header>Klargjøring av mobil for retur</header>
        <span class="prepare-phone-text">Det er viktig at kundens telefon er klargjort for retur. Kunden må selv:</span>
        <ul class="prepare-phone-list">
          <li>Fjerne SIM-kort og eventuelle minnekort</li>
          <li>Slette alt av innhold og data som er lagret på mobilen</li>
          <li>Deaktivere kodelåsen</li>
          <li>Skru av alle stedstjenestene som Find my iPhone, Find my Mobile osv.</li>
          <li>Sette mobilen tilbake til fabrikkinnstillinger</li>
          <li>Pakke den godt ved retur i post</li>
        </ul>
        <div class="prepare-phone-link">
          <a
            data-testid="return-phone-guide-link"
            href="https://www.ice.no/kundeservice/mobiltelefoni/abonnement/mobilbytte/bytte-mobiltelefon/"
            target="_blank"
          >
            Åpne guide for retur av telefon
          </a>
        </div>
        <header>Eierskifte av gammel telefon</header>
        <div class="ownership-text">
          Eierskapet til din gamle telefon blir overtatt av Modino AS i det du mottar din nye telefon. Fra du mottar din nye
          telefon har du 14 dager til å levere inn den gamle telefonen. Om den gamle telefonen ikke blir returnert innen
          fristen vil eierskapet gå tilbake til deg, og du vil motta en faktura på totalt utestående beløp på
          MobilBytte-avtalen
        </div>
      </section>
      <mat-checkbox disableRipple formControlName="mobileOwnership">
        <span class="ownership-check-box">
          Kunden er informert om, og godtar at Modino AS overtar eierskapet av telefonen.
        </span>
      </mat-checkbox>
    </section>
    <div class="form-buttons">
      <app-ice-button color="secondary" testId="return-mobile-phone-back-button" [disabled]="true">Tilbake</app-ice-button>
      <app-ice-button
        color="primary"
        testId="return-mobile-phone-next-button"
        [disabled]="form.invalid"
        [isLoading]="isInitializingRedemption"
        (click)="onNavigateToNextStep()"
      >
        Neste
      </app-ice-button>
    </div>
  </app-ice-card>
}
